/* This candidate layout never creates an account, cart mutation or checkout. */
(() => {
  'use strict';
  const expectedTheme = '202457186385';
  // Bank only. The Meta response has its own guard and never loads this file, so
  // there is no second entry mode here any more: the retired view=ad / entry=ad
  // addresses are forwarded to the Meta response by pk-route-guard.liquid before
  // this runs.
  const mode = 'returning';
  const localTest = ['127.0.0.1', 'localhost'].includes(location.hostname) && document.documentElement.dataset.pkLocalTest === 'true';
  const themeRole = String(window.Shopify?.theme?.role || '').toLowerCase();
  // The published theme on this shop is always the Bank storefront. Pinning the
  // ID alone meant every publish (new theme ID) blanked the catalog, generic PDPs,
  // sign-in and account with the unavailable message. An unpublished preview
  // still has to be the pinned candidate.
  const onShop = window.Shopify?.shop === '31hami-01.myshopify.com';
  const expectedThemeLoaded = onShop && (['main', 'live'].includes(themeRole) ||
    (themeRole === 'unpublished' && String(window.Shopify?.theme?.id) === expectedTheme));
  const active = localTest || expectedThemeLoaded;
  const stores = new Set([location.hostname, 'puppykind.org', 'www.puppykind.org', '31hami-01.myshopify.com']);
  function route(raw, current = location.href) {
    if (!raw || /^(mail[t]o:|tel:|javascript:)/i.test(raw)) return raw;
    const from = new URL(current), url = new URL(raw, from);
    if (!stores.has(url.hostname) || !/^https?:$/.test(url.protocol)) return raw;
    if (raw.startsWith('#')) return raw;
    // Account is the first-party Puppy Kind/Supabase portal. Never send a
    // customer to Shopify's native /account surface.
    // if (/^\/account(?:\/|$)/.test(url.pathname)) {
    //   url.pathname = '/';
    //   url.searchParams.delete('return_url');
    //   url.searchParams.set('view', 'pup-club');
    //   url.hash = 'signin';
    // // Contact Us is one canonical native page on Bank. Do not send it back into
    // // the old support-chat route.
    // } else if (/^\/pages\/cancel-membership\/?$/.test(url.pathname)) {
    //   url.pathname = '/';
    //   url.searchParams.set('view', 'pup-club');
    //   url.searchParams.delete('entry');
    //   url.hash = 'cancel';
    // } else if (url.pathname === '/pages/contact') {
    //   url.searchParams.delete('view');
    //   url.searchParams.delete('entry');
    // } else {
    //   // A Bank link never carries the retired Meta markers.
    //   if (url.searchParams.get('view') === 'ad') url.searchParams.delete('view');
    //   if (url.searchParams.get('entry') === 'ad') url.searchParams.delete('entry');
    // }
    // Keep navigation pinned to the QA theme while it is unpublished. Once the
    // same theme is published, adding preview_theme_id would create a stale
    // private-preview URL and re-trigger the unavailable state.
    if (!localTest && themeRole === 'unpublished') url.searchParams.set('preview_theme_id', expectedTheme);
    if (from.searchParams.get('pb') === '0') url.searchParams.set('pb', '0');
    return url.pathname + url.search + url.hash;
  }
  document.documentElement.dataset.pkEntry = mode;
  window.PK_VIP_PREVIEW = Object.freeze({active, mode, expectedTheme, localTest, route});
  // The old static page has no cancellation form. Use the existing authenticated flow.
  // Only navigate when route() really changes the address (for example it adds the
  // pinned preview_theme_id). A replace to the same address reloads the page, this
  // guard runs again, and the page never settles.
  const sameAddress = (next, current) => {
    const a = new URL(next, current), b = new URL(current);
    return a.origin === b.origin && a.pathname === b.pathname && a.hash === b.hash &&
      new URLSearchParams(a.search).toString() === new URLSearchParams(b.search).toString();
  };
  if (active && /^\/pages\/cancel-membership\/?$/.test(location.pathname)) {
    const next = route(location.href);
    if (!sameAddress(next, location.href)) {
      location.replace(next);
      return;
    }
  }
  // pm-product-offer dispatches a cancelable pm:checkout-request before it touches
  // the cart, and returns without adding anything if the event is cancelled. The
  // portal supplies its own offer dialog, so on the portal we cancel and hand over.
  // "An adapter exists" was the wrong test for that. layout/pk-vip.liquid loads
  // pk-vip-portal.js on every page it renders -- the PDP and the Meta PDP included --
  // so window.PKVip.sourceOffer is always defined and the Meta CTA was always taken
  // over by the portal, which then threw on a catalogue the PDP never populates.
  // The portal SURFACE is what matters, and only the portal templates render it:
  // sections/pk-vip-portal.liquid emits [data-pk-vip-portal], templates/product.json
  // does not. Off that surface the offer is real Shopify commerce and stays real.
  document.addEventListener('pm:checkout-request', event => {
    if (!active || typeof window.PKVip?.sourceOffer !== 'function') return;
    if (!document.querySelector('[data-pk-vip-portal]')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    window.PKVip.sourceOffer(event.detail);
  }, true);
  // Native Shopify commerce forms are real: cart add, cart update, cart -> checkout.
  // Membership forms have no backend yet and must never report a false success.
  const NATIVE_COMMERCE_ACTION = /^\/(cart(\/(add|update|change|clear))?|checkout)(\?|$)/;
  const isNativeCommerceForm = form => {
    // Search is a read-only native page action, not a portal support form.
    if (form.getAttribute('role') === 'search' && String(form.getAttribute('method') || 'get').toLowerCase() === 'get') {
      try { const search = new URL(form.getAttribute('action') || location.href, location.href); if (search.origin === location.origin && /^\/search\/?$/.test(search.pathname)) return true; } catch (_) {}
    }
    if (form.matches('[data-pk-membership-form]')) return false;
    if (['pk-signin-form','pk-chat-signin-form','pk-contact-form','pk-refund-form'].includes(form.id)) return false;
    // The purifier offer form is real commerce as well, but the two tests below both
    // miss it: pm-product-offer posts /cart/add.js itself, so the form carries no
    // /cart action and no name="id". Cancelling it here stopped submitOffer from ever
    // running -- the CTA went silent, nothing reached the cart and no status line was
    // written. It still announces a cancelable pm:checkout-request, which is the one
    // place the portal, and only the portal, takes the offer over.
    if (form.matches('[data-pm-offer-form]') || form.closest('pm-product-offer')) return true;
    // Shopify's {% form %} tag always emits a hidden form_type input (contact, product, ...).
    // The portal's custom forms never carry one, and are already excluded above by ID.
    if (form.querySelector('input[type="hidden"][name="form_type"]')) return true;
    const action = form.getAttribute('action') || '';
    if (NATIVE_COMMERCE_ACTION.test(action)) return true;
    return !!form.querySelector('[name="id"],[name="checkout"],[name="updates[]"]');
  };
  // Outside the pinned preview this guard is inert for commerce. Account links still
  // resolve to the first-party Puppy Kind portal in every entry mode.
  // Membership forms have no backend yet, so they are held (never falsely submitted)
  // in every mode. Inside the pinned preview every other non-native form is still held;
  // outside it, every other form is left to the browser.
  const isMembershipForm = form => form.matches('[data-pk-membership-form]') ||
    ['pk-signin-form','pk-chat-signin-form','pk-contact-form','pk-refund-form'].includes(form.id);
  document.addEventListener('submit', event => {
    const form = event.target;
    if (typeof form?.matches !== 'function' || isNativeCommerceForm(form) || (!active && !isMembershipForm(form))) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (active) window.PKVip?.form(form);
  }, true);
  document.addEventListener('click', event => {
    if (!active) return;
    const target = event.target.closest('a,button');
    if (!target) return;
    if (target.matches('[data-pm-open-chat]')) {
      event.preventDefault(); event.stopImmediatePropagation();
      target.removeAttribute('data-pm-open-chat');
      target.setAttribute('href', '/pages/contact');
      window.location.assign('/pages/contact');
      return;
    }
    if (!target.matches('a[href]')) return;
    // Same-store links are normalized to the Puppy Kind account surface and, while
    // unpublished, gain the pinned preview theme parameter.
    const updated = route(target.getAttribute('href'));
    if (updated !== target.getAttribute('href')) target.setAttribute('href', updated);
  }, true);
  document.addEventListener('DOMContentLoaded', () => {
    document.documentElement.dataset.pkEntry = mode;
    if (!active) {
      document.querySelectorAll('[data-pk-vip-portal]').forEach(el => { el.textContent = 'This private preview is unavailable on this theme.'; });
      return;
    }
    const update = root => root.querySelectorAll('a[href]').forEach(a => a.setAttribute('href', route(a.getAttribute('href'))));
    update(document);
    new MutationObserver(records => records.forEach(r => r.addedNodes.forEach(node => { if (node.nodeType === 1) { if (node.matches('a[href]')) node.setAttribute('href', route(node.getAttribute('href'))); update(node); } }))).observe(document.body, {childList:true,subtree:true});
  });
})();
